import ButtonDialog from 'components/button-dialog';
import { useEffect } from 'react';

const RentalPlateDialog = ({ show, onShow, onClick }) => {
  useEffect(() => {
    if (show && onShow) {
      onShow();
    }
  }, [show]);

  return (
    <ButtonDialog
      title="已綁定租賃車牌"
      items={[
        {
          content: '知道了',
          theme: 'positive',
          onClick,
        },
      ]}
      isShow={show}
    >
      提醒您，租賃車牌到期後，請記得取消車牌綁定，若造成非本人扣款，需與原租車業者聯繫退費方式。
    </ButtonDialog>
  );
};

export default RentalPlateDialog;
